import { ClockIcon } from './ClockIcon';

/**
 * author: Google
 * id 90E7BBD9-12C3-4339-94DE-99A049C8D4B1
 * name clock
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/clock.svg
 * tags
 * - Date / Time 
 */
export const WatchLaterIcon = ClockIcon;
export default WatchLaterIcon